import React from "react"
import classnames from "classnames"
import { WINDOW } from "constants/environment"
import componentParser from "AtomicUtils/componentParser"
import { H2, P } from "AtomicComponents"
import styles from "./Spotlight.less"

class Spotlight extends React.PureComponent {

  componentDidMount(){
    setTimeout(() => {
      if (WINDOW.DeviceOrientationEvent) {
        WINDOW.addEventListener("deviceorientation", this._handleDevice )
      }
    }, 100)
  }

  _handleDevice = (event) => {
    // beta === 90 means vertically in center and More means up and less means down
    // gamma === 0 means horizontally in center

    let height = this.spotlight.clientHeight
    let width = this.spotlight.clientWidth

    let newX = width / 2
    let newY = height / 2

    newY = height / 2 + Math.round(event.beta) * (height/2) / 180 - 90
    newX = width / 2 + Math.round(event.gamma) * (width/2) / 90

    this.spotlightShadow.style.backgroundImage = `radial-gradient(circle at ${newX}px ${newY}px, transparent 20%, rgba(0,0,0,.96) 30%)`
  }

  _handleOnMouseMove = (event) => {
    let x = event.pageX - this.spotlight.offsetLeft
    let y = event.pageY - this.spotlight.offsetTop
    this.spotlightShadow.style.backgroundImage = `radial-gradient(circle at ${x}px ${y}px, transparent 20%, rgba(0,0,0,.96) 30%)`
  }


  render() {
    const { components, children, heading, description } = this.props
    return (
      <div
        ref={c => this.spotlight = c}
        className={classnames({
          [styles.Spotlight]: true
        })}
        onMouseMove={this._handleOnMouseMove}
        >
        {heading && description &&
          <div
            className={classnames({
              [styles.SpotlightHeroContent]: true
            })}
          >
            {heading &&
              <H2 white>
                {heading}
              </H2>
            }
            {description &&
              <P white>
                {description}
              </P>
            }
          </div>
        }
        <div
          ref={c => this.spotlightShadow = c}
          className={classnames({
            [styles.SpotlightShadow]: true
          })}
        ></div>
        {componentParser(components) || children}
      </div>
    )
  }
}


export default Spotlight



// WEBPACK FOOTER //
// ./src/AtomicComponents/Spotlight/Spotlight.jsx